import { isValidAbsoluteFilePath } from 'sharedreact/data/Url';
import SmartNameSupport from 'sharedreact/utils/SmartNameSupport';

function isValidAbsoluteFileUrl (valueString: string): boolean {
  return (
    valueString === '' ||
    SmartNameSupport.containsSmartName(valueString) ||
    isValidAbsoluteFilePath(valueString)
  );
}

function _isValidAbsoluteWindowsPath (valueString: string): boolean {
  return valueString.match(/^[a-zA-Z]:(?:[^<>:"\|\?\*\n])*$/) != null ||
    valueString.match(/^[\\\/][\\\/](?:[^<>:"\|\?\*\n])*$/) != null;
}

function isValidAbsoluteWindowsPath (valueString: string): boolean {
  return (
    valueString === '' ||
    _isValidAbsoluteWindowsPath(valueString));
}

const UrlValidators = {
  isValidAbsoluteFileUrl,
  isValidAbsoluteWindowsPath
};

export {
  isValidAbsoluteFileUrl,
  isValidAbsoluteWindowsPath
};

export default UrlValidators;
